
(() => {
  const SELECTOR = '[data-deferred-slide-media]';
  const DONE = 'done';

  if (window.__deferredSlideMedia) return;
  window.__deferredSlideMedia = true;

  /** @param {Element} slide */
  const hydrate = (slide) => {
    if (!(slide instanceof HTMLElement)) return;
    if (slide.dataset.deferredSlideMedia === DONE) return;
    slide.dataset.deferredSlideMedia = DONE;

    for (const source of slide.querySelectorAll('source[data-srcset]')) {
      if (!(source instanceof HTMLSourceElement)) continue;
      source.srcset = source.dataset.srcset ?? '';
      delete source.dataset.srcset;
    }

    for (const img of slide.querySelectorAll('img[data-srcset], img[data-src]')) {
      if (!(img instanceof HTMLImageElement)) continue;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        delete img.dataset.srcset;
      }
      if (img.dataset.src) {
        img.src = img.dataset.src;
        delete img.dataset.src;
      }
    }
  };

  const hydrateAll = () => {
    for (const slide of document.querySelectorAll(SELECTOR)) hydrate(slide);
  };

  if (!document.querySelector(SELECTOR)) return;

  // Autoplay scrolls the track, so this also covers the untouched-page case.
  const listenerOptions = { passive: true, once: true, capture: true };
  for (const event of ['scroll', 'pointerdown', 'keydown']) {
    document.addEventListener(event, hydrateAll, listenerOptions);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(hydrateAll, { timeout: 3000 });
  } else {
    setTimeout(hydrateAll, 2500);
  }
})();
